import Vue from 'vue'

const mutations = {

  /**
   * @param state
   * @param clients
   */
  SET_CLIENTLIST (state, clients) {
    if (state.client_list.length > 0) {
      state.client_list = []
    }

    for (let index = 0; index < clients.length; index++) {
      state.client_list.push(clients[index])
    }
  },
  ADD_CLIENT (state, client) {
    state.client_list.push(client)
  },
  ADD_SELECTED (state, client) {
    state.client_selected = client
  },

  ADD_CLIENT_TO_CLIENTLIST (state, clientData) {
    state.client_list.push(clientData)
  },

  UPDATE_CLIENT_IN_CLIENTLIST (state, clientData) {
    let updatedClientIndex = state.client_list.findIndex(oldClient => oldClient.id === clientData.id)
    if (updatedClientIndex !== -1) {
      Vue.set(state.client_list, updatedClientIndex, clientData)
    }
  }
}
export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/client/client.mutations.js
// module id = null
// module chunks = 